import React from "react";

import { Tooltip } from "../Helpers/Tooltip";
import { trueOrFalse, required, ifZero, noMaximum } from "../../../helpers/util";

function field(field) {
  if (field.value === 'title') return <>
    <div className="col-xs-4">
      <div className="mb-1">
        <h4 class="box-title mt-4">{field.label}</h4>
      </div>
    </div>
  </>
  else return <>
    <div className="col-xs-4">
      <label className="d-label">
        <Tooltip tooltip={field.tooltip}></Tooltip>  <strong>{field.label}</strong>
      </label>
      <span className="pl-h">
        {field.value}
      </span>
    </div>
  </>
}

function generateRow(inputrow) {
  if (Array.isArray(inputrow)) {
    return inputrow.map((input) => {
      return field(input)
    })
  } else {
    return field(inputrow)
  }
}

export const DisplayInfo = props => props.inputs.map(inputrow => {
  return (<><div className="row row-sm">
    {generateRow(inputrow)}
  </div></>)
})
